import { CompanyUser } from '@/api';
import { createContext } from 'react';

export interface MyCompanyUsersContextData {
    /** The authenticated user's own company user in each company they belong to. */
    myUsers: CompanyUser[];
    /**
     * The same records keyed by company id, for screens scoped to a company
     * other than the selected one.
     */
    myUsersByCompanyId: Map<string, CompanyUser>;
}

export const MyCompanyUsersContext = createContext<
    MyCompanyUsersContextData | undefined
>(undefined);
